export const currencyFormatter = new Intl.NumberFormat(undefined, {
  currency: "inr",
  style: "currency",
  minimumFractionDigits: 0,
});
